// frontend/src/components/games/tictactoe/TicTacToeBoard.tsx

import { Player } from './tictactoeConstants';

interface TicTacToeBoardProps {
  board: (Player | null)[];
  winningLine: number[] | null;
  onCellClick: (index: number) => void;
}

export function TicTacToeBoard({ board, winningLine, onCellClick }: TicTacToeBoardProps) {
  return (
    <div className="ttt-board">
      {board.map((cell, index) => {
        const isWinningCell = !!winningLine && winningLine.includes(index);
        const classNames = [
          'ttt-cell',
          cell ? `filled ${cell.toLowerCase()}` : '',
          isWinningCell ? 'winning' : '',
        ].filter(Boolean).join(' ');

        return (
          <button
            key={index}
            type="button"
            className={classNames}
            onClick={() => onCellClick(index)}
            disabled={!!cell}
            aria-label={cell ? `${cell} işaretli hücre` : 'Boş hücre'}
          >
            {cell}
          </button>
        );
      })}
    </div>
  );
}
